import { Box, Grid, Typography } from '@mui/material';
import { FeaturedNewsIllustration } from '../../../../assets/illustration';
import { AppIcon } from '../../../../components/app-icon/AppIcon';
import { useLatestFeaturedNewsQuery } from '../../../../store/features/news/newsSlice';
import { NewsTabs } from './NewsTabs';
import { NewsTabsSkeleton } from './NewsTabsSkeleton';
import { homeNewsStyles } from './styles';

export const LatestFeaturedNews: React.FC = () => {
  const { isError, isFetching, data: news } = useLatestFeaturedNewsQuery();
  if (isError || (news && news.length === 0)) return null;
  return (
    <Box sx={{ py: 5 }} className="container-fluid">
      <Grid container spacing={2.5} sx={homeNewsStyles.headerGrid}>
        <Grid item xs={12} sm={7} md={6} lg={5} xl={4}>
          <Typography variant="h3">
            Read our{' '}
            <Typography variant="h3" component="span" sx={{ bgcolor: 'warning.light' }}>
              educational news
            </Typography>{' '}
            this week
          </Typography>
        </Grid>
        <Grid item>
          <AppIcon sx={homeNewsStyles.illustration} Icon={FeaturedNewsIllustration} />
        </Grid>
      </Grid>
      {isFetching || !news ? <NewsTabsSkeleton /> : <NewsTabs news={news} />}
    </Box>
  );
};
